import { Spin } from 'antd';
import useGetSettingData from 'hooks/useGetSettingData';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TThirdPartyPageData } from 'types/common';
import { EnumFields, SettingEnum } from 'types/enumerationData';
import { getUrlParam } from 'utils/common';
import AccessRoleStore from 'store/Access/role';
import AccessStore from 'store/Access/permission';
import s from './s.module.less';
import { PermissionModuleKeys } from 'constants/access';
import AccessDeniedPage from 'pages/AccessManagement/AccessDenied';

const ThirdPartyPage = () => {
    const [hasMatch, setHasMatch] = useState(false);
    const [matchedThirdParty, setMatchedThirdParty] = useState<TThirdPartyPageData>();
    const [thirdPartyPageData] = useGetSettingData(EnumFields.OPS_THIRD_PARTY_PAGE);
    const [getRoleStore] = AccessRoleStore.useStore();
    const [getAccessStore] = AccessStore.useStore();
    const roles = getRoleStore('data');
    const access = getAccessStore('data') as Record<PermissionModuleKeys, boolean>;
    const [showWithPermission, setShowWithPermission] = useState(false);

    React.useEffect(() => {
        const key = getUrlParam('key');
        thirdPartyPageData?.forEach((item: SettingEnum) => {
            const contentStr = item.content;
            try {
                const contentObj: TThirdPartyPageData = JSON.parse(contentStr);
                if (contentObj.key === key) {
                    if (!contentObj.permissionKey) {
                        setMatchedThirdParty(contentObj);
                        setHasMatch(true);
                    } else {
                        const hasPermission = access?.[contentObj.permissionKey as PermissionModuleKeys];
                        if (hasPermission) {
                            setMatchedThirdParty(contentObj);
                            setHasMatch(true);
                        } else {
                            setShowWithPermission(true);
                        }
                    }
                }
            } catch (e) {
                console.error(e);
            }
        });
    }, [thirdPartyPageData, access]);

    if (showWithPermission) {
        return <AccessDeniedPage />;
    }

    if (!hasMatch) {
        return <Spin />;
    }
    return (
        <div className={s.wrap}>
            <iframe className={s.iframe} src={matchedThirdParty?.url} title={matchedThirdParty?.title} />
        </div>
    );
};

export default ThirdPartyPage;
